export default "/_nuxt/a1c0f645dd7c5ffacca637d54a047173.svg";